const Form063EN = {
    stepName: {
        importantNotes: "Important Notes",
        schoolOfInformation: "Basic Information",
        changesInSalaryDetails: "Acting Appointment Details",
        salaryParticulars: "Certification",
        noteInformation: "Note Information",
        attachment: "Attachment",
        confirmation: "Confirmation",
    },
    label: {
        header: {
            headerOne: "Important Notes",
        },
        statement:
            "I have read, understand and agree to the above terms and conditions",
        pointOption: {
            fortyNine: "49",
            fortyEight: "48",
            fortySeven: "47",
            fortySix: "46(44B)",
            fortyFive: "45(44A)",
            fortyFour: "44",
            fortyThree: "43",
            fortyTwo: "42",
            fortyOne: "41",
            forty: "40",
            thirtyNine: "39",
            thirtyEight: "38",
            thirtySeven: "37",
            thirtySix: "36(33C)",
            thirtyFive: "35(33B)",
            thirtyFour: "34(33A)",
            thirtyThree: "33",
            thirtyTwo: "32",
            thirtyOne: "31",
            thirty: "30",
            twentyNine: "29",
            twentyEight: "28",
            twentySeven: "27",
            twentySix: "26",
            twentyFive: "25",
            twentyFour: "24",
            twentyThree: "23",
            twentyTwo: "22",
            twentyOne: "21",
            twenty: "20",
            nineteen: "19",
            eighteen: "18",
            seventeen: "17",
            sixteen: "16",
            fifteen: "15",
            fourteen: "14",
            thirteen: "13",
            twelve: "12",
            eleven: "11",
            ten: "10",
            nine: "9",
            eight: "8",
            seven: "7",
            six: "6",
            five: "5",
            four: "4",
            three: "3",
            two: "2",
            one: "1",
            zero: "0",
        },
        schoolSessionOption: {
            am: "AM",
            pm: "PM",
            wholeDay: "Whole Day",
        },
        committeeOption: {
            smc: "School Management Committee",
            imc: "Incorporated Management Committee",
        },
        chooseTheSchoolOption: {
            primarySchool: "Primary School",
            secondarySchool: "Secondary School",
            specialSchool: "Special School",
        },
        schoolOfInformation: "Basic Information",

        schoolName: "School Name",
        schoolCode: "School Code",
        schoolSession: "School Session",
        contactPerson: "Contact Person",
        tel: "Telephone Number",
        contactAndTelText1: "School's contact person",
        contactAndTelText2: "and tel. no.",
        contactAndTelText3: "(for enquiry by EDB in processing this form)",
        committee: "Committee",
        mode: " has approved the following acting appointment",
        ref: "Reference Number",
        date: "Date",
        committeeText1: "The ",
        committeeText2:
            "has approved the following acting appointment (Ref. No.:",
        committeeText3: "and Date:",
        committeeText4: ")",
        committeeText5: "and the consequential change in salary particulars:",
        // two page
        changesInSalaryDetails: "Acting Appointment Details",
        englishName: "Name of Teacher in English",
        chineseName: "Name of Teacher in Chinese",
        hkid: "HKIC No.",
        srn: "SRN",
        substantiveRank: "Substantive Rank",
        actingPeriod: "Acting Period",
        actingPeriodFrom: "Acting Period From",
        actingPeriodTo: "Acting Period To",
        rankOfActingAppointment: "Rank of Acting Appointment",
        conditionsCheck: "",
        schoolHead: "School Head",
        schoolHeadTrue: "Yes",
        schoolHeadFalse: "No",
        actingAllowance: "Acting Allowance",
        difference: "Difference between substantive pay and MPS point",
        point: "MPS point",
        actingText1: "",
        actingText2:
            " % of difference between his/her substantive pay and MPS point ",
        actingText3: "",
        approvalForDetails:
            "For acting appointment to the post of school head, please provide details of prior approval sought from Education Bureau",
        fileRefNo: "File Ref. No.",
        fileDate: "File Date",
        attachmentForSchool: "Approval Letter",
        // three page
        // four page
        personalStatement: "Statement",
        title: "Personal Information Collection Statement",
        //    five page
        attachment: "Staff Establishment and Strength Table",
        chooseTheSchool:
            "Annex for School (For Ordinary Primary School/For Ordinary Secondary School/For Special School)",
        attachmentLink: "Click here to download the Annex form",
        termsConditions:
            "I have read, understood and agreed to the above terms and conditions.",
        confirm: "Confirm",
        collectionStatement: "Personal Information Collection Statement",
        ssdo: "-Respective Regional Education Office [Attn : ",
        ssdo2: "] Education Bureau",
        ssdoLabel: "SSDO",
        declaration:
            "I have read the “Personal Information Collection Statement” and fully understand its content.",
        approverOnly:
            "I understand that an “iAM Smart+” account is required for processing the application.",
        original: "Original",
        duplicate: "Duplicate",
        triplicate: "Triplicate",
        originalText: "-Funds Section, Education Bureau",
        triplicateText: "-School's Record",
    },
    note: {
        note1: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s):",
        note2: "Please complete one form for each acting appointment.",
        note3: "Please read the Personal Information Collection Statement carefully before completing this form.",
        note4: "Please ensure the content of this form is made known to the teacher and he/she has read the Personal Information Collection Statement.",
        note5: "1.All the necessary procedures for promoting a teacher or making acting appointment should be completed before the effective date, including the approval by the SMC/IMC. Under normal circumstances, there should be no retrospective effect for the date of promotion and acting appointment.",
        note6: "2.For secondary schools, secondary special schools or the secondary section of combined level special schools, a full-time regular PGM/SGM/GM who has been recommended and approved to take up the functional duties of a higher office in the rank of PI/PII/PGM/SGM as appropriate on an acting basis for a qualifying period of not less than 30 calendar days will be entitled to draw an acting allowance.",
        note7: "3.If leave exceeding 3 consecutive working days affects the calculation of the qualifying period and/or involves the forfeiture of acting allowance for the whole period of leave of the teacher on the acting appointment to eligible ranks (including leave and intervening public holidays and Sundays), please inform this Bureau for adjustment of acting allowance by completing the Acting Appointment Form (Notification for Adjustment of Acting Allowance of Teacher on Acting Appointment Taking Leave/Absence for More than 3 Consecutive Days).",
        note8: "4.For details, please refer to the Appendix attached to EDB Circular No.8/2004, Should there be a change in the acting up rate, please complete Acting Appointment Form (Notification of Change in Acting-up Rate from 90% to 100%).",
        note9: "5.Starting from the 2019/20 school year, under full implementation of the all-graduate teaching force policy, all teaching posts on the approved establishment of aided schools are graduate teacher posts.  Starting from the 2019/20 school year, the promotion mechanism for the non-graduate grade will cease to operate.  In other words, there should not be any new promotion and acting appointment (for substantive appointment) in the non-graduate grade.",
        note10: "6.EDB will perform pre-processing entitlement checking on each acting appointment.  If the acting appointment of staff would exceed the approved entitlement of teaching staff of the school on the relevant acting appointment date, no Salaries Grant with respect to that acting appointment will be paid to the school until the acting appointment is confirimed in order.",
        //
        note11: "1. The Staff Establishment and Strength Table at the Annex in Step 6 (if any) indicates that a vacancy is available for the above acting appointment.",
        note12: "2. For acting appointment to the post of school head, please provide details of prior approval sought from Education Bureau (File Ref. No. and Date:",
        note12Last: ").",
        note13: "3. I shall inform your Bureau accordingly once the above teacher is confirmed to substantive appointment",
        note13b: " and shall also submit the ‘Staff Promotion’ form.",
        note14: "4. I undertake that if the above teacher’s acting period cannot meet the requirements of qualifying period for granting acting allowance",
        note14b:
            " as specified in paragraph 2 of EDB Circular No. 8/2004, I shall advise the Funds Section of your Bureau promptly with a copy to the respective school development officer.",
        note15: "5. I confirm that the particulars in Basic information, Acting Appointment Details and paragraphs 1 to 2 above are correct. I undertake that the acting appointment will not result in having the number of staff holding the posts at the promotion ranks in excess of our approved entitlement. I also undertake my School shall refund any over-payment of the salaries grant to the Education Bureau.",
        //
        note16: "processing employment-related matters;",
        note17: "processing payment of Salaries Grant and other government funding;",
        note18: "calculation of provident fund contribution;",
        note19: "auditing;",
        note20: "conducting research and compiling statistics to facilitate planning of education services;",
        note21: "processing matters relating to the development of the education profession;",
        note22: "administering and enforcing stipulations under the relevant Code of Aid, Education Ordinance, Education Regulations and the Grant/Subsidized Schools Provident Fund Rules.",
        note23: "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
        note24: "The personal data collected in this form may be disclosed to other government bureaux/departments/agencies authorized to process such information for the purposes mentioned above.",
        note25: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee.",
        note26: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to the respective Senior School Development Officer.",
        // five page
    },
    noteList: {
        noteOne:
            "All the necessary procedures for promoting a teacher or making acting appointment should be completed before the effective date, including the approval by the SMC/IMC. Under normal circumstances, there should be no retrospective effect for the date of promotion and acting appointment.",
        noteTwo:
            "For secondary schools, secondary special schools or the secondary section of combined level special schools, a full-time regular PGM/SGM/GM who has been recommended and approved to take up the functional duties of a higher office in the rank of PI/PII/PGM/SGM as appropriate on an acting basis for a qualifying period of not less than 30 calendar days will be entitled to draw an acting allowance.",
        noteThree:
            "If leave exceeding 3 consecutive working days affects the calculation of the qualifying period and/or involves the forfeiture of acting allowance for the whole period of leave of the teacher on the acting appointment to eligible ranks (including leave and intervening public holidays and Sundays), please inform this Bureau for adjustment of acting allowance by completing the Acting Appointment Form (Notification for Adjustment of Acting Allowance of Teacher on Acting Appointment Taking Leave/Absence for More than 3 Consecutive Days).",
        noteFour:
            "For details, please refer to the Appendix attached to EDB Circular No. 8/2004. Should there be a change in the acting up rate, please complete Acting Appointment Form (Notification of Change in Acting-up Rate from 90% to 100%).",
        noteFive:
            "Prior approval should be sought from Education Bureau. For enquiries, please contact the respective School Development Officers.",
    },
    errorMsg: {
        E0001: "Please input a valid school name",
        E0002: "Please input a valid school code(4 characters)",
        E0003: "Please enter a correct rule(Contains Numeric characters and five special characters which are space( ), plus(+), hash(#), brackets(()) and hyphen(-))",
        E0004: "Please enter a correct rule(Contains alpha-numeric characters and eight special characters which are apostrophe(’), space( ), dot(.), Ampersand(&), comma(,), brackets(()), slash(/) and hyphen(-).)",
        E0005: "Please enter a correct rule(Contains Numeric characters)",
        E0006: "Please enter a valid file ref. No.",
        E0007: "Please input a valid contact person",
        E0008: "Please enter a correct rule(Contains chinese characters and five special characters which are space( ), dot(.), comma(,), apostrophe(’) and hyphen(-).  Number is not allowed.)",
        englishName: "Please input a valid name of teacher in English",
        chineseName: "Please input a valid name of teacher in Chinese",
        srnRule: "Please input a valid SRN with 8 characters",
        countryCode: "Please input a valid country code",
        substantiveRank: "Please input a valid substantive rank",
        rankOfActingAppointment:
            "Please input a valid rank of acting appointment",
        refNum: "Please input a valid reference number",
        hkidEmpty: "The value in the brackets cannot be empty",
        Note001:
            "Note 1.All the necessary procedures for promoting a teacher or making acting appointment should be completed before the effective date, including the approval by the SMC/IMC.  Under normal circumstances, there should be no retrospective effect for the date of promotion and acting appoint.",
    },
};
export default Form063EN;
